import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.583 11.917H5.417c-1.197 0-2.167.97-2.167 2.167v7.583c0 1.197.97 2.167 2.167 2.167h15.166c1.197 0 2.167-.97 2.167-2.167v-7.583c0-1.197-.97-2.167-2.167-2.167zM7.584 11.917V7.584a5.417 5.417 0 0110.833 0v4.333" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);